import React, { useEffect, useState } from 'react';
import 'twin.macro';
import { Icon } from '../icon';
import { LinkIcon, CheckIcon } from 'icons';
import { copyTextToClipboard, useQueryCommandIsSupported } from '../common/hooks';
import { gaEvent } from 'services/ga';
import { notifySuccess } from '../notifications';

const HoverIcon = ({ copySuccess, isComment }) => {
  return (
    <button tw='flex-shrink-0 cursor-copy transition-all hover:scale-125 active:scale-95'>
      <Icon
        Type={!copySuccess ? LinkIcon : CheckIcon}
        color={!copySuccess ? 'icons' : 'brand'}
        size={isComment ? 'medium' : 'base'}
      />
    </button>
  );
};

export const CopyUrl = ({ label, path, isIcon, isComment, ...restProps }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [origin, setOrigin] = useState('');
  const copyIsSupported = useQueryCommandIsSupported();

  useEffect(() => {
    setOrigin(window.location.origin);
  }, []);

  return (
    <>
      {copyIsSupported && origin && (
        <div
          data-type='copy-url'
          onClick={() => {
            copyTextToClipboard(origin + path, () => {
              gaEvent(`dmp_${isComment ? 'comment' : 'detail_page'}`, 'copy_url');
              setCopySuccess(true);
              notifySuccess('url gekopieerd');
              setTimeout(() => {
                setCopySuccess(false);
              }, 2000);
            });
          }}
          {...restProps}
        >
          {isIcon || isComment ? (
            <HoverIcon copySuccess={copySuccess} isComment={isComment} />
          ) : (
            <span>{label || 'Link kopiëren'}</span>
          )}
        </div>
      )}
    </>
  );
};
